import { Component } from '@angular/core';

@Component({
  selector: 'app-privacidad',
  imports: [],
  templateUrl: './privacidad.html',
  styleUrl: './privacidad.css',
})
export class PrivacidadComponent {

}
